import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FlagManagerGroupPickerComponent } from '../flag-manager-group-picker/flag-manager-group-picker.component';
import { FlagGroup } from '../../../../shared/interfaces';

@Component({
  selector: 'app-group-management-bar',
  templateUrl: './group-management-bar.component.html',
  styleUrls: ['./group-management-bar.component.scss'],
})
export class GroupManagementBarComponent implements OnInit {
  @Input() groups: any[];
  @Output() removeGroups = new EventEmitter<any>();
  @Output() mergeGroups = new EventEmitter<{ targetGroup: FlagGroup; selectedGroups: any[] }>();

  @ViewChild('groupPicker', { static: true }) private groupPicker: FlagManagerGroupPickerComponent;

  get selectedGroups() {
    return this.groups?.filter(g => g.checkbox.value);
  }

  constructor() {}

  ngOnInit(): void {}

  selectAll() {
    this.groups.forEach(f => f.checkbox.setValue(true));
  }

  unSelectAll() {
    this.selectedGroups.forEach(f => f.checkbox.setValue(false));
  }

  canMerge() {
    if (this.selectedGroups.length < 2) {
      return;
    }

    const type = this.selectedGroups[0].typeId;
    return !this.selectedGroups.find(g => g.typeId && g.typeId !== type);
  }

  async selectTargetGroup() {
    const targetGroup = await this.groupPicker?.ask(this.selectedGroups);
    if (!targetGroup) {
      return;
    }
    this.mergeGroups.emit({ targetGroup, selectedGroups: this.selectedGroups });
  }
}
